import IE from './IE'

// isIE Returns true if user agent is Internet Explorer 8-11
const isIE = /* @cc_on!@ */ false || !!document.documentMode

export { isIE }

export default IE
